module.exports = __webpack_public_path__ + "img/172.1d874595.jpg";